import { EbCommande } from "./commande";
import { EbDemande } from "./demande";
import { EcCountry } from "./country";
import { EbUser } from "./user";
import { EbEtablissement } from "./etablissement";
import { EbCompagnie } from "./compagnie";
import { EbPslApp } from "./pslApp";
import { TTEvent } from "./tTEvent";
import { Statique } from "../utils/statique";
import { MTEnum } from "./mtEnum";

export class EbTracing{
	ebTtTracingNum: number;
	xEbCommande: EbCommande;
	listEbPslApp: Array<EbPslApp>;
	dateCreation: Date;
	xEbDemande: EbDemande;
	xEcCountryOrigin: EcCountry;
	xEcCountryDestination: EcCountry;
	datePickup: Date;
    dateModification: Date;
    toDelete: boolean;
    toAdd: boolean;
	
	totalWeight: number;
	refTransport: string;
    customerReference: string;
    customRef: String;
	xEbTransporteur: EbUser;
	xEbEtablissementTransporteur: EbEtablissement;
	nomEtablissementTransporteur: string;
	xEbCompagnieTransporteur: EbCompagnie;
	
	listEvent: Array<TTEvent>;
	xEbChargeur: EbUser;
	xEbEtablissementChargeur: EbEtablissement;
    nomEtablissementChargeur: string;
    xEcModeTransport:number;
	xEbChargeurCompagnie: EbCompagnie;
	late: number;
	codePslCourant: MTEnum;
	
	configPsl: string; 
    leadtime: number;

    originPlace: string;
    destinationPlace: string;
    
    constructor(){
        this.ebTtTracingNum = null;
        this.xEbCommande = new EbCommande();
        this.listEbPslApp = new Array<EbPslApp>();
        this.dateCreation = null;
        this.xEbDemande = new EbDemande();
        this.xEcCountryOrigin = new EcCountry();
        this.xEcCountryDestination = new EcCountry();
        this.datePickup = null;
        this.dateModification = null;
        
        this.totalWeight = null;
        this.refTransport = null;
        this.customerReference = null;
        this.customRef = null;
        this.xEcModeTransport=null;
        this.xEbTransporteur = new EbUser();
        this.xEbEtablissementTransporteur = new EbEtablissement();
        this.nomEtablissementTransporteur = null;
        this.xEbCompagnieTransporteur = new EbCompagnie();
        this.toDelete = false;
        this.toAdd = false;

        
        this.listEvent = new Array<TTEvent>();
        this.xEbChargeur = new EbUser();
        this.xEbEtablissementChargeur = new EbEtablissement();
        this.nomEtablissementChargeur = null;
        this.xEbChargeurCompagnie = new EbCompagnie();
        this.late = null;
        this.codePslCourant = null;
        
        this.configPsl = null; 
        this.leadtime = null;
        
        this.originPlace = null; 
        this.destinationPlace = null;
    }

    clone(data){
        this.ebTtTracingNum = data.ebTtTracingNum;
        this.xEbCommande = data.xEbCommande;
        this.listEbPslApp = new Array<EbPslApp>();
        if(data.listEbPslApp){
            data.listEbPslApp.forEach(element => {
                let ebpslApp = new EbPslApp();
                ebpslApp.clone(element);
                this.listEbPslApp.push(ebpslApp);
            });
        }
        this.dateCreation = data.dateCreation;
        this.xEbDemande = data.xEbDemande;
        this.xEcCountryOrigin = data.xEcCountryOrigin;
        this.xEcCountryDestination = data.xEcCountryDestination;
        this.datePickup = data.datePickup;
        this.dateModification = data.dateModification;
        
        this.totalWeight = data.totalWeight;
        this.refTransport = data.refTransport;
        this.customerReference = data.customerReference;
        this.customRef = data.customRef;
        this.xEbTransporteur = data.xEbTransporteur;
        this.xEbEtablissementTransporteur = data.xEbEtablissementTransporteur;
        this.nomEtablissementTransporteur = data.nomEtablissementTransporteur;
        this.xEbCompagnieTransporteur = data.xEbCompagnieTransporteur;
        
        if(!data.listEvent)
            this.listEvent = new Array();
        else
            this.listEvent = Statique.cloneObject(data.listEvent);

        this.xEbChargeur = data.xEbChargeur;
        this.xEbEtablissementChargeur = data.xEbEtablissementChargeur;
        this.nomEtablissementChargeur = data.nomEtablissementChargeur;
        this.xEbChargeurCompagnie = data.xEbChargeurCompagnie;
        this.late = data.late;
        this.codePslCourant = data.codePslCourant;
        
        this.configPsl = data.configPsl; 
        this.leadtime = data.leadtime;
        
        this.originPlace = data.originPlace; 
        this.destinationPlace = data.destinationPlace;
    }
}


// WEBPACK FOOTER //
// ./src/app/classes/tracing.ts